import { Fragment } from 'react/jsx-runtime'
import { ThemeProvider } from 'styled-components'
import Spinner from 'builder/components/Spinner'
import { componentsMap } from './config/components'
import {
  NavHeading,
  NavHeadingContainer,
  NavigationContainer,
  NavList,
  NavListItem,
  ProgressBarContainer,
  ProgressBarFiller,
  ServiceHeader,
  ServiceInfo,
  WidgetContainer,
  ContentContainer,
  ButtonContainer,
} from './styles'
import { Icons } from './config/icons'
import { Service } from './types'

export default function PtDesktop(props: {
  data: Service[]
  setActiveServiceId: (id: string) => void
  activeServiceId: string
  isFetching: boolean
  selectedService: any
  ProgressModalTrigger: React.ReactNode
  categoryId?: string
}) {
  const {
    data,
    setActiveServiceId,
    activeServiceId,
    isFetching,
    selectedService,
    ProgressModalTrigger,
  } = props

  const Widget = isFetching ? componentsMap.Default : componentsMap[selectedService.component]

  return (
    <Fragment>
      <NavigationContainer>
        <NavHeadingContainer>
          <ContentContainer />
          <NavHeading>PROGRESS</NavHeading>
          <ButtonContainer>{ProgressModalTrigger}</ButtonContainer>
        </NavHeadingContainer>

        <NavList>
          {data.map(service => {
            const isActive = activeServiceId === service.id
            const { formattedProgress = '', percentageProgress = 0 } = service.calculatedProgress

            return (
              <ThemeProvider key={service.id} theme={service.theme}>
                <NavListItem isActive={isActive} onClick={() => setActiveServiceId(service.id)}>
                  <Icons service={service} isActive={isActive} isLoading={isFetching} />
                  <ServiceInfo>
                    <ServiceHeader>
                      <span>{service.title}</span>
                      <span>
                        {isFetching ? <Spinner $width="24px" $height="24px" /> : formattedProgress}
                      </span>
                    </ServiceHeader>
                    <ProgressBarContainer isActive={isActive}>
                      <ProgressBarFiller progress={percentageProgress} />
                    </ProgressBarContainer>
                  </ServiceInfo>
                </NavListItem>
              </ThemeProvider>
            )
          })}
        </NavList>
      </NavigationContainer>

      <WidgetContainer>
        <Widget service={selectedService} categoryId={props.categoryId} />
      </WidgetContainer>
    </Fragment>
  )
}
